const popupContentStyle = (width, padding = "0px") => ({
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width,
  padding,
  background: "var(--sl-bg-primary)",
});

export default popupContentStyle;
